import * as React from 'react';

const BadRequestIllustration = React.memo((): React.ReactElement => {
  return (
    <svg
      width="480"
      height="280"
      viewBox="0 0 480 280"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="bad-request-illustration"
    >
      <path
        d="M370.45 244.249C367.157 251.05 361.086 256.11 354.723 260.223C347.768 264.714 340.275 268.321 332.419 270.96C331.341 271.329 330.254 271.672 329.161 272H284.975C284.667 271.667 284.374 271.319 284.097 270.96C281.138 267.19 279.538 262.36 280.118 257.628C280.866 251.549 285.508 245.965 291.521 244.675C297.539 243.381 304.399 246.953 306.229 252.803C307.233 241.53 308.394 229.789 314.417 220.19C319.875 211.501 329.323 205.282 339.561 204.169C345.582 203.546 351.657 204.652 357.065 207.357C357.562 207.606 358.054 207.866 358.535 208.137C361.781 209.967 364.645 212.397 366.974 215.297C373.358 223.336 374.921 235.019 370.45 244.249Z"
        fill="#EBECED"
      />
      <path
        d="M357.673 209.587C337.21 226.298 321.041 247.686 310.52 271.956C310.369 272.3 310.218 272.65 310.072 273H308C308.146 272.65 308.292 272.3 308.443 271.956C310.447 267.257 312.66 262.641 315.092 258.145C320.266 248.585 326.353 239.552 333.269 231.172C340.179 222.781 347.898 215.095 356.314 208.224C356.38 208.169 356.454 208.124 356.532 208.088C356.829 207.959 357.168 207.972 357.453 208.125C357.738 208.278 357.938 208.552 357.995 208.871C358.026 209.151 357.902 209.425 357.673 209.587Z"
        fill="white"
      />
      <path
        d="M366 272.5C366 272.633 365.946 272.76 365.848 272.854C365.75 272.948 365.616 273 365.478 273H107.522C107.234 273 107 272.776 107 272.5C107 272.224 107.234 272 107.522 272H365.478C365.616 272 365.75 272.052 365.848 272.146C365.946 272.24 366 272.367 366 272.5Z"
        fill="#181C1E"
      />
      <path
        d="M307.974 257.487V19.5786C307.974 16.366 308.032 13.1465 307.974 9.93424C307.972 9.79379 307.974 9.65307 307.974 9.51259C307.974 7.49747 305.026 7.49414 305.026 9.51259V247.421C305.026 250.634 304.968 253.854 305.026 257.066C305.028 257.206 305.026 257.347 305.026 257.487C305.026 259.503 307.974 259.506 307.974 257.487V257.487Z"
        fill="#EBECED"
      />
      <path
        d="M324.635 75H287.365C285.507 74.9979 284.002 73.4934 284 71.6368V26.3632C284.002 24.5066 285.507 23.0021 287.365 23H324.635C326.493 23.0021 327.998 24.5066 328 26.3632V71.6368C327.998 73.4934 326.493 74.9979 324.635 75Z"
        fill="#EBECED"
      />
      <path
        d="M194.517 161.511C195.568 160.461 196.105 158.994 195.983 157.506C195.861 156.018 195.092 154.661 193.884 153.8L191.362 137L181 140.294L186.677 155.282C185.35 157.476 185.858 160.326 187.858 161.915C189.859 163.504 192.72 163.33 194.517 161.511H194.517Z"
        fill="#FCD3C9"
      />
      <path
        d="M183.798 153L177.393 123.451C176.124 117.695 177.977 111.702 182.285 107.628C190.484 99.8238 201.021 89.9868 204.661 87.4423C208.077 85.0369 212.211 83.8316 216.402 84.019L216.49 84.0285L222 89.172L209.997 108.689L191.776 119.967L193.803 148.928L183.798 153Z"
        fill="#2969F2"
      />
      <rect x="177" y="113" width="31" height="4" rx="2" fill="#A4ACB0" />
      <rect x="177" y="158" width="31" height="4" rx="2" fill="#A4ACB0" />
      <path
        d="M193.187 272C192.652 272 192.206 271.587 192.159 271.049L179.004 115.135C178.954 114.561 179.373 114.055 179.941 114.004C180.508 113.953 181.01 114.377 181.06 114.951L193.172 259.003L204.94 114.953C204.972 114.582 205.197 114.256 205.531 114.098C205.865 113.94 206.257 113.975 206.559 114.188C206.861 114.401 207.028 114.761 206.996 115.133L194.215 271.047C194.169 271.585 193.723 271.999 193.188 272H193.187Z"
        fill="#A4ACB0"
      />
      <circle cx="222.5" cy="63.5" r="13.5" fill="#FCD3C9" />
      <path d="M229 265H222.225L219 239H229V265Z" fill="#FCD3C9" />
      <path
        d="M210 272H231V264H217.743C213.469 264.005 210.005 267.561 210 271.949L210 272Z"
        fill="#040B2B"
      />
      <path
        d="M229.043 256.974L226.724 256.631C219.687 255.591 219.266 255.528 218.149 255.042C217.579 254.793 217.539 251.035 217.881 229.912C218.132 214.406 218.445 195.11 217.838 184.75C217.786 183.909 217.16 183.212 216.323 183.066C215.486 182.92 214.658 183.362 214.32 184.135C209.084 196.132 200.301 222.979 194.489 240.744C192.467 246.924 190.87 251.805 189.86 254.73C189.455 255.877 188.239 256.53 187.05 256.239C182.267 255.053 182.587 254.549 175.774 252.8C174.549 252.49 173.789 251.276 174.052 250.05C175.284 244.284 197.833 150.793 199.56 141.906C199.677 141.291 200.038 140.749 200.561 140.4C201.084 140.05 201.726 139.923 202.344 140.046C207.421 141.061 210.509 142.137 215.527 143.179C220.94 144.302 226.538 145.464 231.999 146.549C232.542 146.657 233.029 146.954 233.373 147.385C234.724 149.078 236.728 150.029 238.849 151.035C240.279 151.713 237.038 151.652 238.284 152.631C243.327 156.592 236.075 237.039 231.692 255.209C231.401 256.387 230.253 257.152 229.043 256.974V256.974Z"
        fill="#040B2B"
      />
      <path
        d="M228.495 75.7938C227.686 72.3619 231.778 64.9774 230.968 61.5455C230.42 59.2213 224.951 60.8012 223.675 58.7826C222.398 56.7639 220.26 55.1285 217.871 55.1017C215.124 55.0709 212.422 57.1067 209.82 56.2268C207.189 55.3372 206.349 51.7375 207.512 49.2175C208.675 46.6974 211.18 45.0916 213.655 43.8333C217.87 41.6906 222.778 40.1258 227.29 41.5435C230.017 42.4005 232.297 44.2575 234.504 46.0737C236.515 47.7292 238.561 49.4223 239.967 51.6148C242.722 55.9097 242.555 61.6967 240.201 66.2233C237.847 70.75 233.558 74.0718 228.831 76"
        fill="#040B2B"
      />
      <path
        d="M195.278 154.538C196.759 152.074 199.009 140.526 201.782 121.144C203.671 107.913 205.316 94.4691 206.133 87.6017C206.261 86.4719 206.965 85.4875 207.995 84.9962C208.525 84.7416 209.051 84.5006 209.575 84.2733C216.335 81.3451 223.187 80.3749 229.938 81.3893C236.678 82.4203 243.001 85.2891 248.205 89.6781L248.267 89.7358L248.282 89.8182C248.312 89.9709 251.147 105.185 245.34 115.464C239.612 125.606 239.545 152.464 239.545 152.734V153.08L239.212 152.985C230.302 150.45 195.883 154.885 195.536 154.93L195 155L195.278 154.538Z"
        fill="#2969F2"
      />
      <rect x="218" y="120" width="31" height="4" rx="2" fill="#A4ACB0" />
      <rect x="218" y="165" width="31" height="4" rx="2" fill="#A4ACB0" />
      <path
        d="M233.187 273C232.652 273 232.206 272.587 232.159 272.048L219.004 122.137C218.971 121.765 219.137 121.404 219.439 121.19C219.741 120.975 220.133 120.94 220.467 121.097C220.801 121.255 221.027 121.581 221.06 121.952L233.172 259.981L244.94 121.955C244.989 121.38 245.489 120.954 246.057 121.004C246.624 121.054 247.045 121.56 246.996 122.135L234.215 272.045C234.169 272.585 233.723 272.999 233.188 273H233.187Z"
        fill="#A4ACB0"
      />
      <path
        d="M225.117 165.135C224.798 163.732 225.138 162.263 226.046 161.126C226.954 159.988 228.336 159.297 229.822 159.24L241.036 147L248 155.135L235.103 164.245C235.036 166.718 233.067 168.752 230.519 168.979C227.971 169.206 225.651 167.555 225.117 165.135L225.117 165.135Z"
        fill="#FCD3C9"
      />
      <path
        d="M231 157.147L248.714 133.753L239.579 114.365L240.243 91.3705L247.731 90L247.811 90.0394C251.449 92.147 254.269 95.4011 255.82 99.2823C257.484 103.402 260.934 117.418 263.536 128.45C264.917 134.224 263.168 140.294 258.917 144.476L237.187 166L231 157.147Z"
        fill="#2969F2"
      />
      <path
        d="M158.059 266.188L181.956 271.932C182.913 272.184 183.914 271.718 184.334 270.824L204.862 216.341C205.045 215.917 205.046 215.437 204.864 215.014C204.655 214.538 204.26 214.169 203.77 213.992L185.803 207.142C185.229 206.923 184.588 206.958 184.042 207.24C183.566 207.474 183.216 207.902 183.081 208.413L183.08 208.416L170.399 256.435L170.211 256.447C170.138 256.451 162.868 256.945 159.599 260.862C158.365 262.346 157.807 264.276 158.059 266.188Z"
        fill="#D2D5D7"
      />
      <path
        d="M175.419 236.549L175.529 235.511L197.316 237.818L197.206 238.856L175.419 236.549Z"
        fill="#A4ACB0"
      />
      <path
        d="M173.201 245.065L173.629 244.113L191.162 252.002L190.734 252.954L173.201 245.065Z"
        fill="#A4ACB0"
      />
      <path
        d="M199.573 231L179 223.977L179.427 223L200 230.023L199.573 231Z"
        fill="#A4ACB0"
      />
      <path
        d="M201.573 226L181 215.958L181.427 215L202 225.042L201.573 226Z"
        fill="#A4ACB0"
      />
      <path
        d="M171.128 253.082L171.807 252.288L186.706 265.017L186.028 265.81L171.128 253.082Z"
        fill="#A4ACB0"
      />
      <path
        d="M166.625 256.939L167.576 256.508L173.559 269.701L172.608 270.132L166.625 256.939Z"
        fill="#A4ACB0"
      />
    </svg>
  );
});

BadRequestIllustration.displayName = 'BadRequestIllustration';

export { BadRequestIllustration };
